import CartIcon from './ic__cart.svg';
import Text택배배송Icon from './ic__delivery-courier.svg';
import SafeDeliveryIcon from './safe_delivery.svg';
import SafeDeliveryWithTextIcon from './safe_delivery_with_text.svg';

export {
  CartIcon,
  SafeDeliveryIcon,
  SafeDeliveryWithTextIcon,
  Text택배배송Icon,
};
